import { forwardRef } from 'react';
import { Button } from '@core/components/Button';
import { useStore } from '@embed/components/VideoPlayer/Player3/store';
/**
 * The player button override default border style when ui_border_style is
 * provided from the store params. The props borderStyle still takes precedence.
 */
export const PlayerButton = forwardRef((props, ref) => {
    const storeBorderStyle = useStore((state) => state.params?.ui_border_style);
    const borderStyle = props.borderStyle ?? storeBorderStyle;
    return <Button borderStyle={borderStyle} ref={ref} {...props}/>;
});
